// extracted by mini-css-extract-plugin
var _1 = "DocFlowSendingWidgetContent-modulenotification__LGDNv";
export { _1 as "notification" }
